// @ vendors
const { Promise } = require('es6-promise');
// @ commons
const { APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const {
    MORTGAGE_REQUEST_FETCH_OPERATIVE_GENERAL_DATA_REQUEST,
    MORTGAGE_REQUEST_FETCH_OPERATIVE_GENERAL_DATA_SUCCESS,
    MORTGAGE_REQUEST_FETCH_OPERATIVE_GENERAL_DATA_FAILURE,
    MORTGAGE_REQUEST_FETCH_OPERATIVE_GENERAL_DATA_AMORTIZATION_REQUEST,
    MORTGAGE_REQUEST_FETCH_OPERATIVE_GENERAL_DATA_AMORTIZATION_SUCCESS,
    MORTGAGE_REQUEST_FETCH_OPERATIVE_GENERAL_DATA_AMORTIZATION_FAILURE
} = require('constants/actionTypes');

const requestOperativeGeneralDataInProgress = () => ({
    type: MORTGAGE_REQUEST_FETCH_OPERATIVE_GENERAL_DATA_REQUEST
});

const requestOperativeGeneralDataSuccess = (data) => ({
    type: MORTGAGE_REQUEST_FETCH_OPERATIVE_GENERAL_DATA_SUCCESS,
    data: data
});

const requestOperativeGeneralDataFailure = (error) => ({
    type: MORTGAGE_REQUEST_FETCH_OPERATIVE_GENERAL_DATA_FAILURE,
    data: {
        error
    }
});

const requestOperativeGeneralDataAmortizationInProgress = () => ({
    type: MORTGAGE_REQUEST_FETCH_OPERATIVE_GENERAL_DATA_AMORTIZATION_REQUEST
});

const requestOperativeGeneralDataAmortizationSuccess = (data) => ({
    type: MORTGAGE_REQUEST_FETCH_OPERATIVE_GENERAL_DATA_AMORTIZATION_SUCCESS,
    data: data
});

const requestOperativeGeneralDataAmortizationFailure = (error) => ({
    type: MORTGAGE_REQUEST_FETCH_OPERATIVE_GENERAL_DATA_AMORTIZATION_FAILURE,
    data: {
        error
    }
});

const requestOperativeGeneralData = (producto, numeroContrato) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestOperativeGeneralData;
    const isAlreadyFetching = currentState.get('isFetching');

    if (!isAlreadyFetching) {
        const requestData = {
            query: {
                producto,
                numeroContrato
            }
        };

        const url = apiURLBuilder.getURL('mortgageRequestOperativeGeneralData');

        dispatch(requestOperativeGeneralDataInProgress());

        return APIGet({
            dispatch,
            endpoint: 'mortgageRequestOperativeGeneralData',
            url,
            params: requestData
        })
        .then(response => dispatch(requestOperativeGeneralDataSuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(requestOperativeGeneralDataFailure(response.error))
            } else {
                throw response;
            }
        });
    } else {
        return Promise.resolve()
    }
};

const requestOperativeGeneralDataAmortization = (codMonedaPrestamo, producto, numeroContrato, empresa, fechaDesde, fechaHasta, operacion) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestOperativeGeneralDataAmortization;
    const isAlreadyFetching = currentState.get('isFetching');

    if (!isAlreadyFetching) {
        const requestData = {
            query: {
                codMonedaPrestamo,
                producto,
                numeroContrato,
                empresa,
                fechaDesde,
                fechaHasta,
                operacion
            }
        };

        const url = apiURLBuilder.getURL('mortgageRequestOperativeGeneralDataAmortization');

        dispatch(requestOperativeGeneralDataAmortizationInProgress());

        return APIGet({
            dispatch,
            endpoint: 'mortgageRequestOperativeGeneralDataAmortization',
            url,
            params: requestData
        })
        .then(response => dispatch(requestOperativeGeneralDataAmortizationSuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(requestOperativeGeneralDataAmortizationFailure(response.error))
            } else {
                throw response;
            }
        });
    } else {
        return Promise.resolve()
    }
};

module.exports = {
    requestOperativeGeneralData,
    requestOperativeGeneralDataAmortization
};
